import {
  mediaList,
  type MediaItem,
  type MediaType,
} from "@/mocks/media";
import { newsList, type NewsItem } from "@/mocks/news";
import { topicList, type TopicItem } from "@/mocks/topics";

export function getMediaById(id: string): MediaItem | undefined {
  return mediaList.find((item) => item.id === id);
}

export function getMediaByType(type: MediaType): MediaItem[] {
  return mediaList.filter((item) => item.type === type);
}

export function getTopicById(id: string): TopicItem | undefined {
  return topicList.find((item) => item.id === id);
}

export function getNewsById(id: string): NewsItem | undefined {
  return newsList.find((item) => item.id === id);
}

export function getRelatedMedia(item: MediaItem, limit = 6): MediaItem[] {
  const sameType = mediaList.filter(
    (m) => m.type === item.type && m.id !== item.id,
  );
  const sorted = [...sameType].sort((a, b) => b.heat - a.heat);
  return sorted.slice(0, limit);
}

export interface SearchResult {
  media: MediaItem[];
  news: NewsItem[];
}

export function searchContent(keyword: string): SearchResult {
  const q = keyword.trim().toLowerCase();
  if (!q) return { media: [], news: [] };
  const media = mediaList.filter(
    (m) =>
      m.title.toLowerCase().includes(q) ||
      m.synopsis.toLowerCase().includes(q) ||
      m.cast.some((c) => c.toLowerCase().includes(q)) ||
      m.director.toLowerCase().includes(q) ||
      m.genres.some((g) => g.toLowerCase().includes(q)),
  );
  const news = newsList.filter(
    (n) =>
      n.title.toLowerCase().includes(q) ||
      n.summary.toLowerCase().includes(q) ||
      n.category.toLowerCase().includes(q),
  );
  return { media, news };
}

const typePathMap: Record<MediaType, string> = {
  movie: "movie",
  tv: "tv",
  variety: "variety",
};

export function categoryPath(type: MediaType): string {
  return `/category/${typePathMap[type]}`;
}

export function parseMediaType(value?: string): MediaType | null {
  if (value === "movie" || value === "tv" || value === "variety") {
    return value;
  }
  return null;
}

export function formatDate(date: string): string {
  const [y, m, d] = date.split("-");
  if (!y || !m || !d) return date;
  return `${y}年${Number(m)}月${Number(d)}日`;
}